




















import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import Tax from '@/dto/taxes/Tax'
import taxesStore from '@/stores/TaxStore'
import { Routes } from '@/router/routes'
import Country from '@/dto/deliveries/Country'

@Component
export default class TaxDeleteForm extends Vue {
  @Prop(Object)
  model: Tax

  @Prop(Object)
  country: Country

  taxesStore = taxesStore

  async removeTax() {
    const taxId = parseInt(this.$route.params.taxId)

    if (taxId === this.taxesStore.taxId) {
      await this.$router.push({ name: Routes.taxes })
    }

    await this.taxesStore.removeTax(this.model.id as number)
  }
}
